// ═══════════════════════════════════════════════════════════════════
//  layout/MobileBottomNav.js
//  MobileBottomNav
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../socle/theme";
import { MOBILE_SHORT, NAV_ITEMS, mobilePrimaryIds } from "./navigation";

export function MobileBottomNav({ active, onNavigate, role, onMore }) {
  const items = mobilePrimaryIds(role).map((id) => NAV_ITEMS.find((n) => n.id === id)).filter(Boolean);
  const tab = (key, icon, label, on, onClick, color) => (
    <button key={key} onClick={onClick}
      style={{ flex: 1, background: "transparent", border: "none", cursor: "pointer", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 3, color, padding: 0 }}>
      <span style={{ fontSize: 19 }}>{icon}</span>
      <span style={{ fontSize: 9, fontWeight: on ? 700 : 500 }}>{label}</span>
    </button>
  );
  return (
    <div style={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 40, height: 60, background: THEME.surface, borderTop: `1px solid ${THEME.border}`, display: "flex" }}>
      {items.map((item) => {
        const on = active === item.id;
        return tab(item.id, item.icon, MOBILE_SHORT[item.id] || item.label, on, () => onNavigate(item.id), on ? THEME.purple : THEME.textMuted);
      })}
      {tab("more", "⋯", "Plus", false, onMore, THEME.gold)}
    </div>
  );
}
